import User from 'auth/User';
import { useSelector } from 'react-redux';
import permissionService from 'routes/permissionService';
import { PAGES_ENUM, PERMISSION_ENUM } from 'routes/enums';

const useUserHavePermission = (page: PAGES_ENUM, permission: PERMISSION_ENUM) => {
  const user: User = useSelector((state: any) => state.auth.user);

  if (!user) {
    return false;
  }

  return permissionService.hasPermission(user, page, permission);
};

export default useUserHavePermission;
